var _path, _path2, _path3, _path4, _circle, _circle2, _circle3, _path5, _path6, _circle4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImgDeviceCameraOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 30C16 27.7909 17.7909 26 20 26H43C45.2091 26 47 27.7909 47 30V43C47 45.2091 45.2091 47 43 47H20C17.7909 47 16 45.2091 16 43V30Z",
    fill: "#D9D9D9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18 31.5C18 29.8431 19.3431 28.5 21 28.5H41.5C43.1569 28.5 44.5 29.8431 44.5 31.5V41.5C44.5 43.1569 43.1569 44.5 41.5 44.5H21C19.3431 44.5 18 43.1569 18 41.5V31.5Z",
    fill: "url(#paint0_linear_camera_off)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M46 32L58 27.5C59.3127 27.0077 60.7143 27.9781 60.7143 29.3801V43.6199C60.7143 45.0219 59.3127 45.9923 58 45.5L46 41V32Z",
    fill: "#D9D9D9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M48 33.8L57.4 30.275C57.991 30.0534 58.6429 30.4901 58.6429 31.1213V41.8787C58.6429 42.5099 57.991 42.9466 57.4 42.725L48 39.2V33.8Z",
    fill: "url(#paint1_linear_camera_off)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 31.5,
    cy: 36.5,
    r: 6.5,
    fill: "#585858"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 31.5,
    cy: 36.5,
    r: 3.5,
    fill: "#979797"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 31.5,
    cy: 36.5,
    r: 1.6,
    fill: "#C5C5C5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M23 50H40",
    stroke: "#B4B4B4",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5 47V50",
    stroke: "#B4B4B4",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 65,
    cy: 13,
    r: 5,
    fill: "#DB0046"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_camera_off",
    x1: 31.25,
    y1: 28.5,
    x2: 31.25,
    y2: 44.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E0E0E0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_camera_off",
    x1: 53.3214,
    y1: 30.2148,
    x2: 53.3214,
    y2: 42.7852,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E0E0E0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgDeviceCameraOff);
export default __webpack_public_path__ + "static/media/img_device_camera_off.9cdb65fd78ee70532577958f04f0be45.svg";
export { ForwardRef as ReactComponent };